import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import { HeadTag } from 'shared/components';
import { Box, Tab, Tabs } from '@mui/material';
import AIApprovalDataset from './components/AIApprovalDataset';
import AISystemRecorder from './components/AISystemRecorder';
import PublicSubmisstion from './components/PublicSubmisstion';
import { AISystemsService } from 'services/AISystemService';
import { useLocation, useNavigate } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const AISystem = (): ReactElement => {
  const [value, setTabValue] = useState<any>(null);
  const [summary, setSummary] = useState({
    pendingCount: 0,
    approvedCount: 0,
    publicPendingCount: 0,
  });
  const navigate = useNavigate();
  const location = useLocation();
  // API Calls
  const loadSummary = (): void => {
    AISystemsService.getSummaryCount()
      .then((response) => {
        const { data } = response.data;
        setSummary(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // UI Actions
  const handleChange = useCallback(
    (event: React.SyntheticEvent, newValue: number) => {
      setTabValue(newValue);
    },
    []
  );

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  useEffect(() => {
    if (location.state) {
      if (location.state?.isPublic) {
        setTabValue(1);
      } else {
        setTabValue(0);
      }
      navigate(location.pathname, { replace: true, state: null });
      return;
    }
    setTabValue(0);
  }, []);

  // HOoks
  useEffect(() => {
    loadSummary();
  }, []);

  // UI Elements
  return (
    <Box className="ai-inventory ai-system">
      <HeadTag title="AI Systems" />

      <Box className="ai-inventory">
        <AIApprovalDataset
          approvedCount={summary.approvedCount}
          pendingCount={summary.pendingCount}
          publicPendingCount={summary.publicPendingCount}
          onPublicSelect={() => {
            setTabValue(1);
          }}
        />

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="AI Inventory" {...a11yProps(0)} />
            <Tab label="Public Submissions" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <AISystemRecorder />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <PublicSubmisstion />
        </CustomTabPanel>
      </Box>
    </Box>
  );
};

export default AISystem;
